import React, { useEffect, useState } from 'react';

import API from '../../api/API';
import StrisciaRecord from '../../components/statistiche/StrisciaRecord';
import TabellaOrdinabile from '../../components/statistiche/TabellaOrdinabile';
import { LinkGiocatore } from '../../components/statistiche/Link';
// Breadcrumb, caricamento ed errore hanno già le loro regole nel foglio della sezione.
import './Statistiche.css';
import './Indici.css';

const DIMENSIONE = 50;
const ATTESA_MS = 300;

// Fuori dal componente per la stessa ragione dell'indice squadre: TabellaOrdinabile tiene lo
// stato dell'ordinamento e queste non dipendono da niente che cambi.
const colonne = [
  {
    chiave: 'giocatore', etichetta: 'Giocatore', testo: true,
    valore: (r) => `${r.cognome} ${r.nome}`,
    rende: (r) => <LinkGiocatore id={r.id} nome={r.nome} cognome={r.cognome} />,
  },
  { chiave: 'gruppo', etichetta: 'Gruppo', testo: true, valore: (r) => r.gruppo || '—' },
  { chiave: 'edizioni', etichetta: 'Ed.', etichettaLunga: 'Edizioni', valore: (r) => r.edizioni },
  { chiave: 'partite', etichetta: 'P', etichettaLunga: 'Partite', valore: (r) => r.partite },
  { chiave: 'mete', etichetta: 'M', etichettaLunga: 'Mete', valore: (r) => r.mete },
];

// La colonna del giocatore è testuale, e la forma a card scarta le colonne testuali: senza questo
// titolo il nome resterebbe cliccabile solo da desktop.
const titoloGiocatore = (r) => <LinkGiocatore id={r.id} nome={r.nome} cognome={r.cognome} />;
const sottotitoloGiocatore = (r) => r.gruppo || '—';
const badgeGiocatore = (r) => `${r.edizioni} ed.`;

/**
 * I giocatori sono migliaia: qui si pagina in database e si filtra sul server, al contrario
 * dell'indice squadre. Ogni cambio di filtro riparte da pagina 1, altrimenti si finisce a
 * guardare la pagina 7 di un elenco che ora ne ha 2.
 */
export default function IndiceGiocatori() {
  const [q, setQ] = useState('');
  const [sesso, setSesso] = useState('');
  const [pagina, setPagina] = useState(1);
  const [dati, setDati] = useState({ items: [], totale: 0, pagina: 1, dimensione: DIMENSIONE });
  const [caricando, setCaricando] = useState(true);

  useEffect(() => { setPagina(1); }, [q, sesso]);

  useEffect(() => {
    let vivo = true;
    setCaricando(true);
    // L'attesa avvolge la chiamata invece di sfasare il solo testo del filtro: così una
    // sequenza di tasti premuti e un ritorno a pagina 1 restano una richiesta sola, invece di
    // due che si rincorrono.
    const timer = setTimeout(() => {
      API.carriera.giocatori({ page: pagina, size: DIMENSIONE, q: q.trim(), sesso })
        .then((r) => { if (vivo && r.isSuccess) setDati(r.data); })
        .catch(() => { /* l'elenco vuoto lo dice già da sé */ })
        .finally(() => { if (vivo) setCaricando(false); });
    }, ATTESA_MS);
    return () => { vivo = false; clearTimeout(timer); };
  }, [q, sesso, pagina]);

  const pagine = Math.max(1, Math.ceil(dati.totale / DIMENSIONE));

  return (
    <>
      <h1 className="indice-titolo">Giocatori</h1>

      <StrisciaRecord tipo="giocatori" />

      <div className="indice-filtri">
        <input
          type="search"
          className="indice-filtro"
          aria-label="Cerca un giocatore"
          placeholder="Cerca per nome o cognome"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <select
          className="indice-select"
          aria-label="Filtra per sesso"
          value={sesso}
          onChange={(e) => setSesso(e.target.value)}
        >
          <option value="">Tutti</option>
          <option value="m">Maschi</option>
          <option value="f">Femmine</option>
        </select>
      </div>

      <p className="indice-conteggio">{dati.totale} giocatori</p>

      {caricando ? <div className="statistiche-loading">Caricamento…</div> : (
        <TabellaOrdinabile
          colonne={colonne}
          righe={dati.items}
          chiaveRiga={(r) => r.id}
          ordineIniziale={{ campo: 'giocatore', verso: 'asc' }}
          titoloCard={titoloGiocatore}
          sottotitoloCard={sottotitoloGiocatore}
          badgeCard={badgeGiocatore}
          vuoto="Nessun giocatore corrisponde ai filtri"
        />
      )}

      <nav className="indice-paginazione">
        <button type="button" onClick={() => setPagina((p) => p - 1)} disabled={pagina <= 1}>Precedente</button>
        <span>Pagina {pagina} di {pagine}</span>
        <button type="button" onClick={() => setPagina((p) => p + 1)} disabled={pagina >= pagine}>Successiva</button>
      </nav>
    </>
  );
}
